import React from 'react'
import Materials from '../../container/services/materials'

const MaterialsPage = (props) => (
  <Materials {...props} langKey='it' />
)

export default MaterialsPage
